import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';
import { NotificationPagination } from '../../domain/model/notification_pagination';

export interface FetchNotificationByRulerIDRepository {
    (pagination: Pagination, id: number): Promise<NotificationPagination>
}

const fetchNotificationByRulerIDRepository = (axios: AxiosInstance): FetchNotificationByRulerIDRepository => async (pagination: Pagination, id: number) => {
    try {
        const response: AxiosResponse = await axios.get(`/ruler/${id}/notification`, {
            params: pagination
        })

        const notificationPagination: NotificationPagination = response.data
        return notificationPagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchNotificationByRulerIDRepository